import React, { useCallback, useEffect, useState } from "react";
import { Collapse, Card, Spin, Divider, Button, Tooltip } from "antd";
import CorridorMap from "./CorridorMap";
import CorridorColorReferences from "./CorridorColorReferences";
import Corridor from "../../../../../../models/Corridor";
import WarehouseService from "../../../../../../services/WarehouseService";
import { useLanguage } from "../../../../../../context/LanguageContext";
import { SweepPositionShow, SweepShow } from "../../../../../../models/Sweep";
import { PositionSecured, SweepSecurityShow } from "../../../../../../models/Security";


const { Panel } = Collapse;

interface CorridorCollapseProps {
  warehouseIdx: string;
  sweep: SweepSecurityShow;
  onUpdateContent: () => void;
}

const SafetyMap: React.FC<CorridorCollapseProps> = (props) => {
  const { language } = useLanguage();
  const [stateLoading, setStateLoading] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [corridors, setCorridors] = useState<Corridor[]>([]);
  const startsWithCorridorName = (positions: PositionSecured[], corridor: string) => { return positions.filter((position) => position.position_label.startsWith(corridor)); }

  const updateContent = useCallback(() => {
    // setLoading(true);
    if (props.sweep.warehouse) {
      props.onUpdateContent();
      WarehouseService.getCorridors(props.warehouseIdx).then((warehouse) => {
        if (warehouse) {
          setCorridors(warehouse);
          setLoading(false);
        }
      });
    }// eslint-disable-next-line
  }, [props.warehouseIdx]);

  useEffect(() => {
    updateContent();
    const interval = setInterval(() => {
      updateContent();
    }, 15 * 60000);
    return () => clearInterval(interval);
  }, [updateContent]);
  useEffect(() => {
    setStateLoading(false)
  }, []);

  const handleModalOpen = (corridor: Corridor) => {

  };

  const handleModalClose = () => {

  };

  return (
    <Spin spinning={loading || stateLoading}>
      <CorridorColorReferences
        sweepId={props.sweep.idx.toString()}
      />
      <Divider orientation="center">{language === "es" ? "Racks" : "Corridors"}</Divider>
      <Collapse >
        {corridors.map((corridor) => (
          <Panel
            header={language === "es" ? `Rack ${corridor.name}` : `Corridor ${corridor.name}`}
            key={corridor.name}

          >
            <Card>
              <CorridorMap
                sweepId={props.sweep.idx.toString()}
                positionsSecure={startsWithCorridorName(props.sweep.positions, corridor.name)}
                corridor={corridor}
              />
            </Card>
          </Panel>
        ))}
      </Collapse>

    </Spin>
  );
};

export default SafetyMap;
